import { render, staticRenderFns } from "./TrainingPlanDetailsPage.vue?vue&type=template&id=259ae73c&"
import script from "./TrainingPlanDetailsPage.vue?vue&type=script&lang=js&"
export * from "./TrainingPlanDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports